import moment from 'moment';
import { coinDesc } from '@/api/const';

const coins = { USD: '$', BTC: 'Ƀ', ETH: 'Ξ', BCH: ''};

export function unit(v, coin, higherUnit = false) {
  return v && (coin === 'ETH' || coin === 'ETC' ?
    higherUnit ? '/TH/Day' : '/MH/Day' :
    higherUnit ? '/PH/Day' : '/TH/Day'
  );
}

export function totalReward(perUnit, blockchainInfo) {
  const { coin } = blockchainInfo;
  const hashrate = blockchainInfo.hashrate / (coin === 'ETH' || coin === 'ETC' ? 10 ** 6 : 10 ** 12);
  return perUnit * hashrate;
}

export function hashrate(v, coin, appendUnit = true) {
  v /= coin === 'ETH' || coin === 'ETC' ? 10 ** 6 : 10 ** 12;
  const unit = appendUnit ? (coin === 'ETH' || coin === 'ETC' ? ' MH' : ' TH') : '';

  const i = Math.round(v);
  return i.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + unit;
}

export function price(v, coin = 'USD', d = 4, defaultUnit = '') {
  const i = Math.floor(v);
  const ip = i.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const pp = (v - i).toFixed(d).replace('0.', '');
  return v && `${coins[coin] || defaultUnit} ${ip}.${pp}`;
}

export function unitPrice(v, payoffCoin, coin = 'USD', d = 4, defaultUnit = '') {
  v *= coinDesc[payoffCoin].unitFactor;
  return price(v, coin, d, defaultUnit);
}

export function percent(v, d = 0) {
  return v && (v * 100).toFixed(d) + '%';
}

export function date(v, format = 'DD MMM, YYYY') {
  return moment(v).utc().format(format);
}
